<template>
  <div class="step-content">
    <div class="content">
      <slot name="content"></slot>
    </div>
    <footer>
      <v-divider />
      <div class="d-flex justify-end">
        <slot name="footer"></slot>
      </div>
    </footer>
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/variables';

.step-content {
  display: grid;
  grid-template-areas:
    'content'
    'footer';
  .content {
    grid-area: content;
    min-height: 45vh;
  }
  footer {
    grid-area: footer;
    margin: variables.$horizontalAppPadding 0 0 0;
    padding-bottom: 32px;
  }
}
</style>
